import moment from 'moment';

export const increaseDate = (
  date = new Date(),
  param = 'hours',
  quantity = 3,
  format = 'DD/MM/YYYY'
) => moment(date).add(quantity, param).format(format);
